import { parseDateOnly } from '../utils/dateHelpers';

// Phone number formatting
export const formatPhoneNumber = (value: string | null): string => {
  if (!value) return '';
  
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, '');

  // Format based on number of digits
  if (digits.length <= 3) {
    return digits;
  } else if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  } else {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  }
};

// ZIP code validation
export const validateZipCode = (zip: string): boolean => {
  return /^\d{5}$/.test(zip);
};

// Email validation
export const validateEmail = (email: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

// Phone number validation (allows formatted or unformatted)
export const validatePhoneNumber = (phone: string): boolean => {
  const digits = phone.replace(/\D/g, '');
  return digits.length === 10;
};

// Date validation (must be in the past)
export const validateDate = (date: string): boolean => {
  const inputDate = parseDateOnly(date);
  return !isNaN(inputDate.getTime()) && inputDate < new Date();
};

// Required field validation
export const validateRequired = (value: string | boolean): boolean => {
  if (typeof value === 'boolean') {
    return value === true;
  }
  return value.trim().length > 0;
};

// Name validation (letters, digits, spaces, hyphens, apostrophes, and periods — Unicode-aware)
export const validateName = (name: string): boolean => {
  return /^[\p{L}\p{N}\s\-'.]+$/u.test(name);
};

// Address validation (letters, numbers, spaces, and common address characters)
export const validateAddress = (address: string): boolean => {
  return /^[\p{L}\p{N}\s.,#\-']+$/u.test(address);
};

// City validation (letters, spaces, hyphens, and periods)
export const validateCity = (city: string): boolean => {
  return /^[\p{L}\s\-.]+$/u.test(city);
};

// Voter ID validation (alphanumeric)
export const validateVoterId = (id: string): boolean => {
  return /^[A-Za-z0-9]+$/.test(id);
};

// Precinct validation (numbers and optional letters)
export const validatePrecinct = (precinct: string): boolean => {
  return /^[A-Za-z0-9]+$/.test(precinct);
}; 